export default __webpack_public_path__ + "terrain-map-500-7fbc3c93108d90702842c59f9815adaa.png";